export default {"src":"/_next/static/media/logo-icon.1eae7811.svg","height":236,"width":208};